import React from 'react';
import SettingsPage from '@peoplenet/vi-components-ui/src/admin/settings/container/settings';
import { hasAccess } from '../security/util';

const adminPage = () => {
  // if user is internal, settings cannot be saved
  const canSave = !hasAccess(['videoIntelligenceInternal']);

  return (
    <div className="bodycontent admin__geotab_wrapper">
      <SettingsPage userCanSave={canSave} />
    </div>
  );
};

export default adminPage;
